import { paths } from '@app/routes/paths';
import { Role } from '@features/auth';
import { useAuth } from '@features/auth/hooks/useAuth';
import { tDynamic } from '@i18n/helpers';
import { DesktopOnlyScreen } from '@shared/components/feedback/DesktopOnlyScreen';
import { useTranslation } from 'react-i18next';
import { Outlet, useNavigate } from 'react-router-dom';

import { usePhoneGate } from './usePhoneGate';

/**
 * The shell's outlet behind the phone gate. A page that is not built for phones is never mounted
 * there (nor its code loaded); the desktop-only screen takes its place and offers the price
 * catalog to those who may open it.
 */
export function PhoneGatedOutlet() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { hasRole } = useAuth();
  const { desktopOnly, titleKey } = usePhoneGate();

  if (!desktopOnly) return <Outlet />;

  return (
    <DesktopOnlyScreen
      pageTitle={titleKey ? tDynamic(t, titleKey) : undefined}
      onOpenCatalog={
        hasRole([Role.Tenant])
          ? () => {
              void navigate(paths.priceCatalog);
            }
          : undefined
      }
    />
  );
}
